var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15757 10.6031C0.939197 10.3604 0.764508 10.154 0.63815 10C0.764508 9.84604 0.939197 9.63964 1.15757 9.3969C1.65168 8.84765 2.36638 8.11573 3.24801 7.38495C5.02546 5.91164 7.41264 4.5 10 4.5C12.5874 4.5 14.9745 5.91164 16.752 7.38495C17.6336 8.11573 18.3483 8.84765 18.8424 9.3969C19.0608 9.63964 19.2355 9.84604 19.3618 10C19.2355 10.154 19.0608 10.3604 18.8424 10.6031C18.3483 11.1523 17.6336 11.8843 16.752 12.6151C14.9745 14.0884 12.5874 15.5 10 15.5C7.41264 15.5 5.02546 14.0884 3.24801 12.6151C2.36638 11.8843 1.65168 11.1523 1.15757 10.6031Z",
    stroke: "#2990FB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9,
    r: 4.5,
    stroke: "#2990FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5429f5a9bfc1df6c431ead2c6b4a2902.svg";
export { ForwardRef as ReactComponent };